import { types } from 'mobx-state-tree';

import { RelationshipTypeEnum } from '../definitions/RelationshipType';

import OptionalIdentifier from '../types/OptionalIdentifier';
import Contact from './Contact';


const Relationship = types.model('Relationship', {
    id: OptionalIdentifier,
    relationshipType: types.maybe(RelationshipTypeEnum),
    contact: types.reference(Contact),
    relationTo: types.reference(Contact),
});

export default Relationship;
